<template>
    <ModalFormCard :action="action" class="modal-default wide" v-bind="{ errors, saving }">
        <template #title>{{ isEdit ? 'Edit' : 'Create' }} {{ options.task == 0 ? 'task' : 'event' }}</template>

        <input :value="options?.task" name="appointment" type="hidden" />

        <Input v-model:value="value.title" class="input-white" :label="label + ' title'" name="title" placeholder="Add title" :limit="30" />

        <Textarea
            v-model:value="value.description"
            :textarea-class="[
                'transition-all duration-500 ease-in-out',
                {
                    'min-h-[254px]': size,
                    'min-h-[134px]': !size,
                },
            ]"
            class="mt-4 transition-all duration-500 ease-in-out"
            :label="label + ' description'"
            name="description"
            placeholder="Add description"
            rows="5"
        />

        <Select
            v-if="contactId == undefined || contactIdSearch != null"
            v-model:value="contactIdSearch"
            name="belongs_id"
            label="Assign to contact"
            class="mt-4"
            :search-enabled="true"
            :options="contacts"
            value-key="id"
            @searchKeyup="searchContacts"
            @update:value="contactSelected"
            dropdownIcon="IconSearch"
            :onSearchTriggerGetWithNull="true"
            placeholder="Search contacts by name, email, phone number or address"
            searchPlaceholder="Search contacts by name, email, phone number or address"
        >
            <template #option="{ option, selected }">
                <div class="py-2" v-if="searchCompanies">
                    <!-- <div class="w-2 h-2 rounded-full mr-3" :class="[option.archived_at == null ? 'bg-green-600' : 'bg-grey-900']" /> -->
                    <p>{{ option.name }}</p>
                    <p class='text-14 text-grey-900 !font-normal' v-if='!selected'>{{ option.user.first_name != null ? option.user.fullName() : 'No customer name' }}</p>
                </div>

                <div class="flex items-center" v-else>
                    <p>{{ option.fullName() }}</p>
                </div>
            </template>
        </Select>

        <div v-if="deals != undefined && deals != null" class="grid grid-cols-1 gap-3 mt-4">
            <CanHaveDeal :contact-id="contactId" :model-id="modelId" :model-type="modelType" :deals="deals" />
        </div>

        <template v-else>
            <input type="hidden" :value="contactId" name="belongs_id" />
            <input type="hidden" :value="searchCompanies ? 2 : 102" name="belongs_type" />
            <!-- <input type="hidden" :value="103" name="belongs_type" /> -->
        </template>

        <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
            <InputDropdownDatePicker
                :apply="false"
                :tab-index="3"
                :value="value.start_date"
                class="col-span-2"
                input-class="!h-12"
                :label="label == 'Task' ? 'Due date' : 'Start date'"
                name="start_date"
                placeholder="DD/MM/YYYY"
                @change="setTheMonth"
            />

            <TimePicker
                :tab-index="4"
                :value="value.start_time"
                :label="label == 'Task' ? 'Due time' : 'Start time'"
                name="start_time"
                @change="setHour"
            />
        </div>

        <input :value="value.starts_at" name="starts_at" type="hidden" />
        <input :value="value.ends_at" name="ends_at" type="hidden" />

        <div class="grid lg:grid-cols-2 mt-4 gap-3" v-if="!isTask">
            <Select
                v-model:value="value.duration"
                :disabled="hasEnd || saving"
                :has-none="true"
                :options="durations"
                class="input-white"
                label="Duration"
                name="duration"
                placeholder="Set duration"
            />

            <InputCheckbox class="lg:mt-10" name="has_end" value="1" :checked="hasEnd" @clicked="setEnd">
                <p class="text-13 text-grey-900 pl-2">Add end date</p>
            </InputCheckbox>
        </div>

        <div v-if="hasEnd && !isTask" class="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
            <InputDropdownDatePicker
                :apply="false"
                :value="value.end_date"
                class="col-span-2"
                input-class="!h-12"
                label="End date"
                name="end_date"
                placeholder="DD/MM/YYYY"
                @change="setTheMonthEnd"
            />

            <TimePicker :value="value.end_time" label="End time" name="end_time" @change="setHourEnd" />
        </div>

        <!-- <InputCheckbox
            class="mt-6"
            name="completed_at"
            @clicked="
                () => {
                    value.completed_at = value.completed_at == null ? (editingModel.completed_at != null ? editingModel.completed_at : $moment().format()) : null
                }
            "
            :value="value.completed_at != null ? value.completed_at : $moment().format()"
            :checked="value.completed_at != null"
            v-if="isEdit"
        >
            <p class="text-13 text-grey-900 pl-2">{{ value.completed_at == null ? 'Mark as completed' : 'Completed at' }} {{ $help.formatDateTime(value.completed_at, { date: true, time: true }) }}</p>
        </InputCheckbox> -->

        <div class="modal-buttons">
            <ButtonSaving :disabled="saving" class="default button-black h-12 col-span-2" name="published_at" value="1">
                {{ isEdit ? 'Save' : 'Create' }}
                {{ options.task == 0 ? 'task' : 'event' }}
            </ButtonSaving>

            <div class="col-span-2">
                <button
                    v-if="editingModel == null || editingModel.published_at == null"
                    :disabled="saving"
                    :value="null"
                    class="default button-purple h-12"
                    name="published_at"
                >
                    Save draft
                </button>

                <!-- <button class="button-purple col-span-2 lg:col-span-1 h-12 default" v-if="!isEdit" @click="$emit('close')">Cancel</button> -->
                <button class="button-purple col-span-2 lg:col-span-1 h-12 default" v-else @click="editingModel.destroy()">Delete {{ options.task == 0 ? 'task' : 'event' }}</button>
            </div>
        </div>
    </ModalFormCard>
</template>

<script>
import Deal from '~/models/deal.js'
import Task from '~/models/task.js'
import Contact from '~/models/contact.js'
import Appointment from '~/models/appointment.js'
import Company from '~/models/company.js'
import Modal from '~/mixins/modal.js'
import TimePicker from '~/components/customer/input/time-picker.vue'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'

export default {
    components: {
        TimePicker,
        CanHaveDeal,
    },
    mixins: [Modal],

    data() {
        return {
            label: this.options.task == 0 ? 'Task' : 'Event',
            durations: [
                // { value: 0, html: 'None' },
                { value: 5, html: '5 minutes' },
                { value: 10, html: '10 minutes' },
                { value: 15, html: '15 minutes' },
                { value: 25, html: '25 minutes' },
                { value: 30, html: '30 minutes' },
                { value: 45, html: '45 minutes' },
                { value: 60, html: '1 hour' },
                { value: 90, html: '1 hour 30 minutes' },
                { value: 120, html: '2 hours' },
                { value: 150, html: '2 hours 30 minutes' },
                { value: 180, html: '3 hours' },
                { value: 1440, html: 'All day' },
            ],
            hasEnd: this.editingModel?.ends_at != null ? true : false,
            setDeal: false,
            deals: this._options?.deals,
            contacts: [],
            contactIdSearch: null,
        }
    },

    created() {
        this.setup((this.editingModel != null && this.editingModel.appointment == 0) || this.options.task == 0 ? Task : Appointment)

        if (this.options.starts_at != undefined) {
            this.value.start_date = this.$moment(this.options.starts_at).format('DD/MM/YYYY')
            this.value.start_time = this.$moment(this.options.starts_at).format('HH:mm')
        }

        if (!this.isEdit) {
            this.value.start_date = this.$moment().format('DD/MM/YYYY')
            this.value.start_time =
                (this.editingModel != null && this.editingModel.appointment == 0) || this.options.task == 0 ? '17:00' : '12:00'

            if (!(this.editingModel != null && this.editingModel.appointment == 0) || this.options.task == 0) {
                this.value.duration = 30
            }
        }

        if (! this.searchCompanies) {
            this.getDeals()
        }
    },

    methods: {
        async getDeals() {
            if (this._options == undefined && this.contactId != undefined) {
                let deals = await this.$axios.get('/actions/contact-deals/' + this.contactId)
                this.deals = Deal.fill(deals.deals)
            }
        },

        searchContacts(value) {
            if (this.searchCompanies) {
                this.$axios.get('/admin/actions/company-search?search=' + value)
                    .then((res) => {
                        this.contacts = Company.fill(res.companies)
                    })
            } else {
                this.$axios.get('/actions/contacts-search?search=' + value).then((res) => {
                    this.contacts = Contact.fill(res.contacts)
                })
            }
        },

        async contactSelected() {
            await this.getDeals()
        },

        setTheMonth(value, format) {
            this.value.start_date = value
        },

        setTheMonthEnd(value, format) {
            this.value.end_date = value
        },

        setHour(value) {
            this.value.start_time = value
        },

        setHourEnd(value) {
            this.value.end_time = value
        },

        setEnd(event) {
            this.hasEnd = !this.hasEnd

            if (this.hasEnd) {
                // this.value.duration = null

                if (this.editingModel?.ends_at != null) {
                    this.value.end_date = this.$moment(this.editingModel.ends_at).format('DD/MM/YYYY')
                    this.value.end_time = this.$moment(this.editingModel.ends_at).format('H:mm')
                } else if (this.value.end_date == null) {
                    this.value.end_date = this.value.start_date
                    this.value.end_time = this.value.start_time
                }
            } else {
                // this.value.end_date = null
                // this.value.end_time = null

                if (this.editingModel?.duration != null) {
                    this.value.duration = this.editingModel.duration
                }
            }
        },
    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        },

        searchCompanies() {
            return this.user.hasRole('zapo.employee')
        },

        contactId() {
            console.log('here')
            console.log(this.contactIdSearch != null)
            if (this.contactIdSearch != null) {
                return this.contactIdSearch
            }

            if (this.editingModel != null && parseInt(this.editingModel.belongs_type) == 103) {
                console.log(this.editingModel)
                return this.editingModel.belongs.contact_id
            }

            console.log(this.modelType, this.modelId)
            
            if (parseInt(this.modelType) == 2) {
                return this.modelId
            }

            return this.editingModel?.belongs_id || this.modelId
        },

        isTask() {
            return this.options.task == 0
        },
    }
}
</script>
